export default {
  'merchantManagement.title': 'Merchant List',
  'merchantManagement.form.merchantName': 'Merchant Name',
  'merchantManagement.form.merchantName.placeholder': 'Please select Merchant Name',
  'merchantManagement.form.search': 'Search',
  'merchantManagement.form.reset': 'Reset',
  'merchantManagement.operation.add': 'Add',
  'merchantManagement.operation.delete': 'Delete',
  'merchantManagement.actions.refresh': 'Refresh',
  'merchantManagement.actions.density': 'Density',
  'merchantManagement.actions.columnSetting': 'Column Settings',
  'merchantManagement.columns.index': 'Serial Number',
  'merchantManagement.columns.merchantName': 'Merchant Name',
  'merchantManagement.columns.status': 'Status',
  'merchantManagement.columns.createdAt': 'Creation Time',
  'merchantManagement.columns.updatedAt': 'Update Time',
  'merchantManagement.columns.status.enabled': 'Enabled',
  'merchantManagement.columns.status.disabled': 'Disabled',
  'merchantManagement.columns.operations': 'Operations',
  'merchantManagement.columns.operations.edit': 'Edit',
  'merchantManagement.columns.operations.delete': 'Delete',
  'merchantManagement.columns.operations.deleteConfirm': 'Are you sure you want to delete this record?',
  'merchantManagement.size.mini': 'Mini',
  'merchantManagement.size.small': 'Small',
  'merchantManagement.size.medium': 'Medium',
  'merchantManagement.size.large': 'Large',
  'merchantManagement.modal.addTitle': 'Add Merchant',
  'merchantManagement.modal.editTitle': 'Edit Merchant',
  'merchantManagement.modal.merchantName': 'Merchant Name',
  'merchantManagement.modal.merchantName.placeholder': 'Please enter merchant name',
  'merchantManagement.modal.merchantName.required': 'Please enter merchant name',
  'merchantManagement.modal.status': 'Status',
  'merchantManagement.modal.status.enabled': 'Enabled',
  'merchantManagement.modal.status.disabled': 'Disabled',
  'merchantManagement.modal.createSuccess': 'Created successfully',
  'merchantManagement.modal.createFailed': 'Failed to create',
  'merchantManagement.modal.updateSuccess': 'Updated successfully',
  'merchantManagement.modal.updateFailed': 'Failed to update',
  'merchantManagement.operation.deleteSuccess': 'Deleted successfully',
  'merchantManagement.operation.deleteFailed': 'Failed to delete',
  'merchantManagement.operation.noSelection': 'Please select merchants to operate first',
  'merchantManagement.operation.batchDeleteConfirm': 'Are you sure you want to delete the selected merchants?',
  'merchantManagement.operation.batchDeleteSuccess': 'Batch delete successful',
  'merchantManagement.operation.batchDeleteFailed': 'Batch delete failed',
};

